import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

        this.type = this.getData('type') ? this.getData('type') : 'chars';
        this.animated = typeof this.getData('animated') === 'string';
        this.onlyDesktop = typeof this.getData('desktop') === 'string';

        if(this.onlyDesktop && window.isMobile) {
            return;
        }
        
        gsap.delayedCall(1, () => {
            let chars = this.el.textContent.split('');
            this.el.innerHTML = '';

            for (let i = 0; i < chars.length; i++) {
                let span = document.createElement('span');
                span.innerText = chars[i] == '' ? '\xa0\xa0' : chars[i];
                this.el.append(span);
            }

            if(this.type == 'lines') {
                this.splitLines();
            }
            if(this.type == 'words') {
                this.splitWords();
            }
        });

        // if(this.animated) this.animate();
    }

    splitLines() {
        let $wordSpans = Array.from(this.el.querySelectorAll('span'));
        var lineArray = [],
            lineIndex = 0,
            lineStart = true;

        $wordSpans.forEach((el, idx) => {
            let top = el.getBoundingClientRect().top;

            if (lineStart) {
                lineArray[lineIndex] = [idx];
                lineStart = false;

            } else {
                var $next = el.nextSibling;

                if ($next != null) {
                    if ($next.getBoundingClientRect().top > top) {
                        lineArray[lineIndex].push(idx);
                        lineIndex++;
                        lineStart = true
                    }
                } else {
                    lineArray[lineIndex].push(idx);
                }
            }
        });

        for (let i = 0; i < lineArray.length; i++) {
            let start = lineArray[i][0];
            let end = lineArray[i][1] + 1;

            let wrap = document.createElement('div');
            wrap.classList.add('line-wrap');
            let container = document.createElement('div');
            container.classList.add('line-container');
            container.append(wrap);

            /* no end value pushed to array if only one word last line*/
            if (!end) {
                wrap.append($wordSpans[start]);
            } else {

                let slicedSpans = $wordSpans.slice(start, end);
                slicedSpans.forEach(el => {
                    wrap.append(el);
                });
            }

            this.el.append(container);
        }
    }

    splitWords() {
        let $wordSpans = Array.from(this.el.querySelectorAll('span'));
        var wordArray = [],
            wordIndex = 0,
            wordStart = true;

        $wordSpans.forEach((el, idx) => {
            let top = el.getBoundingClientRect().top;

            if (wordStart) {
                wordArray[wordIndex] = [idx];
                wordStart = false;

            } else {
                var $next = el.nextSibling;

                if ($next != null) {

                    if ($next.innerText == '') {
                        wordArray[wordIndex].push(idx);
                        wordIndex++;
                        wordStart = true
                    }
                } else {
                    wordArray[wordIndex].push(idx);
                }
            }
        });


        for (let i = 0; i < wordArray.length; i++) {
            let start = wordArray[i][0];
            let end = wordArray[i][1] + 1;

            let wrap = document.createElement('span');
            wrap.classList.add('word-wrap');

            /* no end value pushed to array if only one word last line*/
            if (!end) {
                wrap.append($wordSpans[start]);
            } else {

                let slicedSpans = $wordSpans.slice(start, end);
                slicedSpans.forEach(el => {
                    wrap.append(el);
                });
            }

            this.el.append(wrap);
        }
    }

    animate() {

        let $words = this.el.querySelectorAll('.word-wrap');

        $words.forEach(($word) => {
            gsap.to($word.querySelectorAll('span'), {
                alpha: 1,
                duration: 1.6,
                stagger: 0.1
            });
        });

    }
}
